import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import CardWrapper from "../../CardWrapper";
import Card from "../../Card";
import { getDVD } from "../../../../state/selectors/DVD.selectors";
import { getPathogenicityColorByAllNames } from "../../../../common/helpers/Constant";

const DVDCard = ({ card, dvdData }) => {
  const isDisabled = !dvdData;
  const pathoColor =
    dvdData && dvdData?.pathogenicity
      ? getPathogenicityColorByAllNames(dvdData.pathogenicity)
      : card.color;
  return (
    <CardWrapper {...card} isDisabled={isDisabled} color={pathoColor}>
      <>
        {dvdData?.pathogenicity && (
          <div data-testid="dvdCard-pathogenicity">
            <b
              style={{
                color: pathoColor,
              }}
            >
              {dvdData.pathogenicity}
            </b>
          </div>
        )}
        {dvdData?.disease && (
          <div data-testid="dvdCard-disease">
            <b>{dvdData.disease}</b>
          </div>
        )}
      </>
    </CardWrapper>
  );
};

DVDCard.propTypes = {
  card: PropTypes.instanceOf(Card).isRequired,
  dvdData: PropTypes.shape({
    pathogenicity: PropTypes.string,
    disease: PropTypes.string,
    comment: PropTypes.string,
  }),
};

DVDCard.defaultProps = {
  dvdData: null,
};

const mapStateToProps = (state) => ({
  dvdData: getDVD(state),
});

export default connect(mapStateToProps)(DVDCard);
